var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4167 11.667C19.3333 11.5837 19.3333 11.5003 19.25 11.417L16.75 8.91699C16.4167 8.58366 15.9167 8.58366 15.5833 8.91699C15.25 9.25033 15.25 9.75033 15.5833 10.0837L16.6667 11.167H12.8333C12.3333 11.167 12 11.5003 12 12.0003C12 12.5003 12.3333 12.8337 12.8333 12.8337H16.6667L15.5833 13.917C15.25 14.2503 15.25 14.7503 15.5833 15.0837C15.75 15.2503 16 15.3337 16.1667 15.3337C16.3333 15.3337 16.5833 15.2503 16.75 15.0837L19.25 12.5837C19.3333 12.5003 19.4167 12.417 19.4167 12.3337C19.5 12.0837 19.5 11.917 19.4167 11.667Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 17.0833C14 17.5833 13 17.8333 12 17.8333C8.75 17.8333 6.16667 15.25 6.16667 12C6.16667 8.75 8.75 6.16667 12 6.16667C13 6.16667 14 6.41667 14.9167 6.91667C15.3333 7.16667 15.8333 7 16.0833 6.58333C16.3333 6.16667 16.1667 5.66667 15.75 5.41667C14.5833 4.83333 13.3333 4.5 12 4.5C7.83333 4.5 4.5 7.83333 4.5 12C4.5 16.1667 7.83333 19.5 12 19.5C13.3333 19.5 14.5833 19.1667 15.75 18.5C16.1667 18.25 16.25 17.75 16.0833 17.3333C15.8333 17 15.3333 16.8333 14.9167 17.0833Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.a83a295c58e80ed29b787b4ad7378f08.svg";
export { ForwardRef as ReactComponent };